module.exports = __webpack_public_path__ + "img/gbmf-blue.3b4c9704.svg";